import React from "react";
import SearchBar from "./SearchBar";
import { FaPlus } from "react-icons/fa";
import Pagination from "./pagination";
import Select from "react-select";
import moment from "moment-timezone";
import { FiFilter } from "react-icons/fi";
import DateFilter from "./DateFilter";
import { customStyles } from "./SelectStyle";

const Table = ({
  title,
  buttonTitle,
  searchTerm,
  showSearchbar,
  setSearchTerm,
  setSearchData,
  onAddClick,
  columns,
  data,
  actions,
  onPageChange,
  pageCount,
  filterOptions,
  selectedFilter,
  onFilterChange,
  pageLimitOptions,
  selectedPageLimit,
  onPageLimitChange,
  dateFilter,
  toggle,
  setToggle,
  savedStartDate,
  savedEndDate,
  handleClearDates,
  setStartDate,
  setEndDate,
  handleSaveDate,
  startDate,
  endDate,
  exportButton,
  onExport,
  exportCsv,
  onExportCSV,
  copyButton,
  handleCopy
}) => {

  return (
    <div className="my-3 font-sans text-foreground">
      <section className="bef-card shadow-theme">
        <div className="h-1.5 card-gradient-strip" />
        <div className="bg-card px-4 sm:px-5 py-3 sm:py-4 flex flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between rounded-t-xl">
          <div className="min-w-0">
            <p className="font-heading text-base sm:text-xl py-1 font-bold text-primary tracking-tight truncate uppercase">
              {title || "Table Title"}
            </p>
          </div>
          {showSearchbar && (
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              setSearchData={setSearchData}
            />
          )}
          {filterOptions && (
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full lg:w-auto">
              <p className="text-xs sm:text-sm font-bold text-muted-foreground">Filter:</p>
              <Select
                className="w-full sm:min-w-[180px]"
                value={filterOptions?.find(
                  (option) => option.value === selectedFilter
                )}
                onChange={onFilterChange}
                options={filterOptions}
                styles={customStyles}
                getOptionLabel={(e) => e.label}
                placeholder="Select filter"
              />
            </div>
          )}
          <div className="flex flex-wrap items-center gap-2">
            {copyButton &&
              <button
                onClick={handleCopy}
                className="bef-btn-primary"
              >
                <p className="font-bold">{copyButton}</p>
              </button>
            }
            {buttonTitle && (
              <div className="flex-shrink-0">
                <button
                  className="bef-btn-primary"
                  onClick={onAddClick}
                >
                  <FaPlus className="font-bold text-white w-4 h-4" />
                  <p className="font-bold">{buttonTitle}</p>
                </button>
              </div>
            )}
            {dateFilter && (
              <div className="flex items-end justify-end sm:flex-row flex-col-reverse gap-2 sm:gap-3">
                {savedStartDate && savedEndDate && (
                  <button
                    onClick={handleClearDates}
                    className="bef-btn-secondary"
                  >
                    <p className="font-bold">Clear</p>
                  </button>
                )}
                <button
                  onClick={() => setToggle(true)}
                  className="bef-btn-primary"
                >
                  <FiFilter className="font-bold text-white w-4 h-4" />
                  <p className="font-bold">Filter</p>
                  {savedStartDate && savedEndDate && (
                    <p className="hidden md:inline">
                      (
                      {`${moment(savedStartDate).format("Do MMMM")} - ${moment(
                        savedEndDate
                      ).format("Do MMMM")}`}
                      )
                    </p>
                  )}
                </button>
              </div>
            )}

            {exportButton && (
              <button
                className="bef-btn-primary"
                onClick={onExport}
              >
                Export PDF
              </button>
            )}
            {exportCsv && (
              <button
                className="bef-btn-primary"
                onClick={onExportCSV}
              >
                Export CSV
              </button>
            )}
          </div>
        </div>
        <div className="bg-card bef-table-wrap px-0 border-t border-border">
          <table className="w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                <th className="cursor-pointer border-y border-border bg-secondary p-3 sm:p-4 text-center text-[11px] sm:text-xs font-extrabold uppercase tracking-wide text-primary">
                  {columns[0]?.label || columns[0]?.header}
                </th>

                {actions && (
                  <th className="cursor-pointer border-y border-border bg-secondary p-3 sm:p-4 text-center text-[11px] sm:text-xs font-extrabold uppercase tracking-wide text-primary">
                    Actions
                  </th>
                )}

                {columns.slice(1).map((column, index) => (
                  <th
                    key={index}
                    style={column.width ? { width: `${column.width}px` } : undefined}
                    className="cursor-pointer border-y border-border bg-secondary p-3 sm:p-4 text-center text-[11px] sm:text-xs font-extrabold uppercase tracking-wide text-primary"
                  >
                    {column.label || column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex} className="transition-colors hover:bg-secondary/60">
                    <td className="p-3 sm:p-4 border-b border-border text-center text-xs sm:text-sm text-foreground">
                      {columns[0].render
                        ? columns[0].render(row[columns[0].key], row, rowIndex)
                        : row[columns[0].key]}
                    </td>

                    {actions && (
                      <td className="p-3 sm:p-4 border-b border-border text-center">
                        <div className="flex items-center justify-center gap-1 sm:gap-2 font-sans text-md font-medium leading-none text-foreground">
                          {actions?.map((action, actionIndex) => {

                            const isDisabled = action.disabled ? action.disabled(row) : false;
                            return (
                              <button
                                key={actionIndex}
                                className={`h-9 w-9 sm:h-10 sm:w-10 rounded-xl flex items-center justify-center uppercase text-primary transition-all duration-300 ${isDisabled ? " opacity-20  " : "hover:bg-secondary hover:text-accent active:bg-secondary"}`}
                                onClick={() => action.onClick(row)}
                                disabled={isDisabled}
                              >
                                {typeof action?.icon === "function"
                                  ? action?.icon(row)
                                  : action?.icon}
                              </button>
                            )
                          })}
                        </div>
                      </td>
                    )}

                    {columns.slice(1).map((column, colIndex) => (
                      <td key={colIndex} className="p-3 sm:p-4 border-b border-border text-center text-xs sm:text-sm text-foreground">
                        {column.render
                          ? column.render(row[column.key], row, rowIndex)
                          : row[column.key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length + (actions ? 1 : 0)}
                    className="p-4 text-center"
                  >
                    <div className="flex items-center justify-center p-4 sm:p-6 w-full">
                      <div className="text-center animate__animated animate__fadeIn animate__delay-1s max-w-md">
                        <h2 className="font-heading text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-4">
                          No Data Found
                        </h2>
                        <p className="text-sm text-muted-foreground mb-4 sm:mb-6">
                          Unfortunately, we couldn&apos;t find any results matching
                          your search.
                        </p>
                        <div className="mt-4 sm:mt-6">
                          <button
                            className="bef-btn-primary px-6 py-3 text-sm shadow-theme"
                            onClick={() => window.location.reload()}
                          >
                            Try Again
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {
          pageCount && (
            <>
              <div className="flex flex-col sm:flex-row sm:flex-wrap justify-between gap-3 bg-card items-center px-4 sm:px-5 py-3 border-t border-border rounded-b-xl">
                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <label htmlFor="pageLimit" className="text-xs sm:text-sm font-bold text-muted-foreground whitespace-nowrap">
                    Page Limit:
                  </label>
                  <Select
                    className=""
                    value={pageLimitOptions?.find(
                      (option) => option.value === selectedPageLimit
                    )}
                    onChange={(e) => onPageLimitChange(e.value)}
                    options={pageLimitOptions.map((option) => ({
                      value: option.value,
                      label: option.label,
                    }))}
                    styles={customStyles}
                    menuPlacement="top"
                  />
                </div>
                <Pagination pageCount={pageCount} onPageChange={onPageChange} />
              </div>
            </>
          )
        }
      </section >
      {toggle && (
        <DateFilter
          toggle={toggle}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          handleDateSubmit={handleSaveDate}
          startDate={startDate}
          endDate={endDate}
          onClose={() => {
            setToggle(false);
            handleClearDates();
          }}
        />
      )}
    </div >
  );
};

export default Table;
